import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as IGWhite } from "../assets/ig_icon_white.svg";
import LocationsMenu from "./LocationsMenu";

const BOOK_URL = "https://app.playtomic.io/tenants/8466df30-5b02-492a-8cda-7bd631040099";

const TempoWordmark = () => (
  <svg viewBox="0 0 945.25 184.75" aria-hidden="true">
    <g>
      <path d="M77.3,119.4c-6.78,0-13.18-1.66-18.83-4.58c-0.31-0.16-0.61-0.31-0.92-0.48v1.04v33.45v0.95v30.87h39.48v-30.87v-0.95v-33.45v-1.04c-0.3,0.17-0.61,0.32-0.92,0.48C90.48,117.74,84.08,119.4,77.3,119.4z" />
      <path d="M77.3,4.1c-40.9,0-74.18,33.28-74.18,74.18c0,4.94,0.5,9.77,1.42,14.44c0.06,0.31,0.12,0.61,0.19,0.92h0.94h32.52h0.98c-0.12-0.3-0.25-0.61-0.36-0.92c-1.69-4.5-2.63-9.36-2.63-14.44c0-22.67,18.44-41.11,41.11-41.11c22.67,0,41.11,18.44,41.11,41.11c0,5.08-0.93,9.95-2.63,14.44c-0.12,0.31-0.24,0.61-0.36,0.92h0.98h32.52h0.94c0.06-0.3,0.13-0.61,0.19-0.92c0.93-4.67,1.42-9.5,1.42-14.44C151.48,37.38,118.2,4.1,77.3,4.1z" />
      <path d="M233.58,155.6V53.72h-36.31V29.15h101.16v24.57h-36.49V155.6H233.58z" />
      <path d="M355.46,155.6V29.15h83.1v24.57h-54.55v22.94h46.06v24.57h-46.06v29.81h54.55v24.57H355.46z" />
      <path d="M495.59,155.6V29.15h33.96l30.89,77.5l29.99-77.5h33.96V155.6h-28.54V79.55l-24.39,61.24h-22.94l-24.39-61.42v76.23H495.59z" />
      <path d="M681.43,155.6V29.15h50.22c8.67,0,16.5,1.57,23.48,4.7c6.98,3.13,12.49,7.65,16.53,13.55c4.03,5.9,6.05,12.95,6.05,21.13c0,8.07-1.96,15.08-5.87,21.04c-3.91,5.96-9.33,10.57-16.26,13.82c-6.93,3.25-14.9,4.88-23.94,4.88h-21.68v47.33H681.43z M709.97,83.88h20.95c6.74,0,11.41-1.54,14-4.61c2.59-3.07,3.88-6.65,3.88-10.75c0-3.85-1.3-7.32-3.88-10.39c-2.59-3.07-7.26-4.61-14-4.61h-20.95V83.88z" />
      <path d="M875.84,157.77c-8.67,0-16.95-1.51-24.84-4.52c-7.89-3.01-14.93-7.34-21.14-13.01c-6.2-5.66-11.08-12.52-14.63-20.59c-3.55-8.07-5.33-17.16-5.33-27.28c0-10.12,1.78-19.21,5.33-27.28c3.55-8.07,8.43-14.93,14.63-20.59c6.2-5.66,13.25-9.99,21.14-13.01c7.89-3.01,16.17-4.52,24.84-4.52c8.67,0,16.98,1.51,24.93,4.52c7.95,3.01,15.02,7.35,21.23,13.01c6.2,5.66,11.11,12.53,14.72,20.59c3.61,8.07,5.42,17.16,5.42,27.28c0,10.12-1.81,19.21-5.42,27.28c-3.61,8.07-8.52,14.93-14.72,20.59c-6.2,5.66-13.28,10-21.23,13.01C892.82,156.26,884.51,157.77,875.84,157.77z M875.84,131.94c5.9,0,11.68-1.45,17.34-4.34c5.66-2.89,10.32-7.25,14-13.1c3.67-5.84,5.51-13.22,5.51-22.13c0-9.03-1.87-16.47-5.6-22.31c-3.73-5.84-8.43-10.18-14.09-13.01c-5.66-2.83-11.38-4.25-17.16-4.25s-11.47,1.42-17.07,4.25c-5.6,2.83-10.24,7.17-13.91,13.01c-3.67,5.84-5.51,13.28-5.51,22.31c0,8.91,1.81,16.29,5.42,22.13c3.61,5.84,8.22,10.21,13.82,13.1C864.19,130.49,869.94,131.94,875.84,131.94z" />
    </g>
  </svg>
);

interface SubPageNavProps {
  ctaLabel: string;
  ctaHref: string;
  /** Optional handler instead of href — overrides ctaHref click behavior. */
  onCtaClick?: () => void;
  /** Highlight which sub-page link the user is on so we don't link to it. */
  active?: "free-intro" | "mornings" | "pricing" | "events" | "coaching" | null;
}

export const SubPageNav: React.FC<SubPageNavProps> = ({ ctaLabel, ctaHref, onCtaClick, active = null }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("v2-menu-open", menuOpen);
    return () => document.body.classList.remove("v2-menu-open");
  }, [menuOpen]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const handleCta = (e: React.MouseEvent) => {
    if (onCtaClick) {
      e.preventDefault();
      onCtaClick();
    }
  };

  return (
    <>
      <header className="v2-nav solid">
        <div className="v2-container v2-nav-inner">
          <div className="v2-nav-left">
            <a
              href="https://www.instagram.com/tempopadelclub"
              target="_blank"
              rel="noopener noreferrer"
              className="v2-nav-ig"
              aria-label="Tempo on Instagram"
            >
              <IGWhite />
            </a>
            <Link to="/">Home</Link>
            <LocationsMenu enabled={!menuOpen} />
          </div>
          <Link to="/" className="v2-nav-logo" aria-label="Tempo — home">
            <TempoWordmark />
          </Link>
          <div className="v2-nav-right">
            <Link to="/morning" aria-current={active === "mornings" ? "page" : undefined}>Mornings</Link>
            <Link to="/events" aria-current={active === "events" ? "page" : undefined}>Events</Link>
            <Link to="/coaching" aria-current={active === "coaching" ? "page" : undefined}>Coaching</Link>
            <Link to="/#membership" aria-current={active === "pricing" ? "page" : undefined}>Pricing</Link>
            <Link to="/free-intro" aria-current={active === "free-intro" ? "page" : undefined}>Free Intro</Link>
            <Link to="/#visit">Contact</Link>
            <a href={ctaHref} className="v2-nav-cta" onClick={handleCta}>
              <span className="dot"></span> {ctaLabel}
            </a>
            <button
              type="button"
              className={`v2-menu-toggle ${menuOpen ? "open" : ""}`}
              aria-label="Open menu"
              aria-expanded={menuOpen}
              aria-controls="v2-mobile-drawer"
              onClick={() => setMenuOpen((v) => !v)}
            >
              <span></span>
            </button>
          </div>
        </div>
      </header>

      <nav
        className={`v2-mobile-drawer ${menuOpen ? "open" : ""}`}
        id="v2-mobile-drawer"
        aria-label="Mobile"
      >
        <Link to="/" className="m-link" onClick={closeMenu}>
          <span>Home</span>
          <span className="idx">01</span>
        </Link>
        <Link to="/morning" className="m-link" onClick={closeMenu} aria-current={active === "mornings" ? "page" : undefined}>
          <span>Mornings</span>
          <span className="idx">02</span>
        </Link>
        <Link to="/events" className="m-link" onClick={closeMenu} aria-current={active === "events" ? "page" : undefined}>
          <span>Events</span>
          <span className="idx">03</span>
        </Link>
        <Link to="/coaching" className="m-link" onClick={closeMenu} aria-current={active === "coaching" ? "page" : undefined}>
          <span>Coaching</span>
          <span className="idx">04</span>
        </Link>
        <Link to="/#membership" className="m-link" onClick={closeMenu} aria-current={active === "pricing" ? "page" : undefined}>
          <span>Pricing</span>
          <span className="idx">05</span>
        </Link>
        <Link to="/free-intro" className="m-link" onClick={closeMenu} aria-current={active === "free-intro" ? "page" : undefined}>
          <span>Free Intro</span>
          <span className="idx">06</span>
        </Link>
        <Link to="/#visit" className="m-link" onClick={closeMenu}>
          <span>Contact</span>
          <span className="idx">07</span>
        </Link>
        <LocationsMenu mobile enabled={menuOpen} onNavigate={closeMenu} />
        <a
          href={ctaHref}
          className="m-cta"
          onClick={(e) => {
            closeMenu();
            handleCta(e);
          }}
        >
          <span className="dot"></span> {ctaLabel}
        </a>
        <div className="m-foot">
          <span>1729 Brittmoore Rd</span>
          <span>Houston, TX 77043</span>
          <span>+1 713 570 6716</span>
        </div>
      </nav>
    </>
  );
};

export const SubPageFoot: React.FC = () => (
  <footer className="v2-foot">
    <div className="v2-container">
      <div className="v2-foot-mark-wrap">
        <div className="v2-foot-mark"><TempoWordmark /></div>
      </div>

      <div className="v2-foot-grid">
        <div>
          <h4>Club</h4>
          <p>
            A padel &amp; pickleball club in Houston, Texas. Courts, wellness,
            and a place to unwind.
          </p>
        </div>
        <div>
          <h4>Play</h4>
          <ul>
            <li>
              <Link to="/#courts">Courts</Link>
            </li>
            <li>
              <Link to="/#membership">Membership</Link>
            </li>
            <li>
              <Link to="/morning">Mornings</Link>
            </li>
            <li>
              <Link to="/events">Events</Link>
            </li>
            <li>
              <Link to="/coaching">Coaching</Link>
            </li>
            <li>
              <Link to="/free-intro">Free Intro</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>Visit Us</h4>
          <ul>
            <li>
              <Link to="/#visit" className="v2-foot-location">
                <span>Brittmoore</span>
                <span className="v2-foot-address">1729 Brittmoore Rd, Ste A, Houston</span>
              </Link>
            </li>
            <li>
              <Link to="/#heights" className="v2-foot-location">
                <span>Heights · Coming soon</span>
                <span className="v2-foot-address">8200 Washington Ave, Houston</span>
              </Link>
            </li>
            <li>
              <a href="mailto:info@tempo.club">info@tempo.club</a>
            </li>
            <li>
              <a href="tel:+17135706716">+1 713 570 6716</a>
            </li>
            <li>
              <a
                href="https://instagram.com/tempopadelclub"
                target="_blank"
                rel="noopener noreferrer"
              >
                @tempopadelclub
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4>Book</h4>
          <ul>
            <li>
              <a href={BOOK_URL} target="_blank" rel="noopener noreferrer">
                Book a Court
              </a>
            </li>
            <li>
              <Link to="/#membership">Pricing</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="v2-foot-bottom">
        <span>© Tempo 2026. All rights reserved.</span>
        <span>Made in Houston</span>
      </div>
    </div>
  </footer>
);

export const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

export { BOOK_URL };
